import { useMemo } from 'react';
import { buildInquiryPricingView } from '../inquiryPricingModel';

const useInquiryPricing = ({ listing, formValues, intl }) =>
  useMemo(() => buildInquiryPricingView({ listing, formValues, intl }), [
    listing,
    formValues,
    intl,
  ]);

export default useInquiryPricing;
